export function ADD_POS_NOTIFICATIONS(payload) {
	return {
		type: 'ADD_POS_NOTIFICATIONS',
		payload: payload,
	};
}

export function MARK_POS_NOTIFICATIONS_READ(payload) {
	return {
		type: 'MARK_POS_NOTIFICATIONS_READ',
		payload: payload,
	};
}

export function SET_POS_NOTIFICATIONS_UNREAD_COUNT(payload) {
	return {
		type: 'SET_POS_NOTIFICATIONS_UNREAD_COUNT',
		payload: payload,
	};
}

export function RESET_POS_NOTIFICATIONS() {
	return {
		type: 'RESET_POS_NOTIFICATIONS',
	};
}
